module.exports = __webpack_public_path__ + "img/who-2.6e15e974.png";